import { render, staticRenderFns } from "./SettingsDeviceSelector.vue?vue&type=template&id=20d652d3&"
import script from "./SettingsDeviceSelector.vue?vue&type=script&lang=js&"
export * from "./SettingsDeviceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports